import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6fc013c6&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=6fc013c6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports